module.exports = __webpack_public_path__ + "static/adam-celadin-ee39c87d20fb577ec037da85973445c7.jpg";